// extracted by mini-css-extract-plugin
module.exports = {"docs-slider":"docs-slider","docsSlider":"docs-slider","slick-list":"slick-list","slickList":"slick-list"};